import CentraImage from "@/components/CentraImage";
import type { getProductModalComponent } from "@/lib/api/formatting/rorosTweed/productPage";
import getPriceList from "@/lib/centra/getPriceList";
import useSelection from "@/lib/hooks/useSelection";

import styles from "./productModal.module.scss";

type Props = {
  show: boolean;
  data: ReturnType<typeof getProductModalComponent>["data"] | undefined;
  scrollToTop: () => void;
};

const UI = ({ show, data, scrollToTop }: Props) => {
  const { priceList } = useSelection();
  const media = data?.media;
  const name = data?.name;
  const categoryName = data?.categoryName;
  const variantName = data?.variantName;
  const prices = data?.prices;
  const price = prices && getPriceList(prices, +priceList);

  const displayPriceBeforeDiscount = price?.priceBeforeDiscount;
  const displayPrice = price?.price;

  return (
    <figure className={styles.container}>
      <button
        className={`${styles.wrapper} ${show ? styles.show : ""}`}
        onClick={scrollToTop}
      >
        {media && (
          <div className={styles.imageContainer}>
            <div className={styles.imageWrapper}>
              <CentraImage src={media.uri} alt={media.alt} />
            </div>
          </div>
        )}
        <div className={styles.details}>
          <div className={styles.titleContainer}>
            <div className={styles.nameContainer}>
              <p className={styles.name}>{name}</p>
              <p className={styles.category}>{categoryName}</p>
            </div>
            <p className={styles.variant}>{variantName}</p>
          </div>
          <div className={styles.pricingContainer}>
            <div className={styles.pricing}>
              {displayPriceBeforeDiscount &&
                displayPriceBeforeDiscount !== displayPrice && (
                  <p className={styles.originalPrice}>
                    {price?.priceBeforeDiscount}
                  </p>
                )}
              <p className={styles.price}>{price?.price}</p>
            </div>
            <p className={styles.arrow}>↑</p>
          </div>
        </div>
      </button>
    </figure>
  );
};

export default UI;
